import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Organization } from "@domain/organization/organization";
import { readableCount } from "@utils/readableCount";
import { useAuthModalBlocker } from "@ui/components/auth/useAuthModalBlocker";
import { useModalTools } from "@ui/modals/modalContext";
import { FollowersModal } from "@ui/pages/profilePage/followersModal";

interface OrganizationDataProps extends React.HTMLAttributes<HTMLDivElement> {
	organization: Organization;
}
export const OrganizationData: React.FC<OrganizationDataProps> = ({ organization, ...htmlProps }) => {
	const { createModal } = useModalTools();
	const blockAction = useAuthModalBlocker();

	return (
		<Container
			{...htmlProps}
			onClick={
				organization.followerCount > 0
					? () =>
							blockAction(() => createModal((close) => <FollowersModal close={close} profileId={organization.id} />))
					: undefined
			}
		>
			<span>
				<b>
					{readableCount(organization.followerCount)} {I18n.t("profile.card.followers")}
				</b>
			</span>
		</Container>
	);
};

const Container = styled.div`
	${({ onClick }) => onClick && "cursor: pointer"};
`;
